import { Link } from 'react-router-dom'

import styles from './styles.module.css'
import { useAuth } from '@/hooks/useAuth'

export function Header() {
  const { token, admin, signOut } = useAuth()

  return (
    <div className={styles.header}>
      {!admin && (
        <Link to={'/'}>
          <img src="/logo/posso.png" />
        </Link>
      )}

      <div className={styles.container}>
        {token && admin ? (
          <>
            <Link className={styles.FakeButton} onClick={signOut} to={'/'}>
              Sair
            </Link>
            <Link className={styles.FakeButton} to={'/institution'}>
              Instituições
            </Link>
            <Link className={styles.FakeButton} to={'/interested-partners'}>
              Interessados
            </Link>
            <Link className={styles.FakeButton} to={'/aluno'}>
              Alunos
            </Link>
            <Link className={styles.FakeButton} to={'/show-pe-friends'}>
              Amigos PE
            </Link>
            <Link className={styles.FakeButton} to={'/blogs'}>
              Blogs
            </Link>
          </>
        ) : (
          <>
            <Link className={styles.FakeButton} to={'/aluno/login'}>
              Aluno
            </Link>
            <Link className={styles.FakeButton} to={'/institution/login'}>
              Instituição
            </Link>
          </>
        )}
      </div>
    </div>
  )
}
